import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Ugla3D, useUgla3dStateManager } from '@ugla-france/ugla-3d-library';
import { useEffect } from 'react';
import KitchenSelectionPage from './pages/KitchenSelectionPage';
import ConfiguratorPage from './pages/ConfiguratorPage';
import { uglaFile } from './uglaFileExample';

function App() {
  const stateManager = useUgla3dStateManager();

  useEffect(() => {
    stateManager.reset();
    stateManager.setModel(new Ugla3D(uglaFile));
  }, [stateManager]);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<KitchenSelectionPage />} />
        <Route path="/configurator/:kitchenName" element={<ConfiguratorPage />} />
      </Routes>
    </Router>
  );
}

export default App;
